import logo from './assets/logo.png';
import {Discord} from './ImageLoader';

import {Page_Projects,Blackjack_Demo}  from './pages/Projects';
import Page_About     from './pages/About';
import Page_Payments  from './pages/Payments';
import Page_Home from './pages/Home';
import Page_404  from './pages/Page404';
import Cookie_Policy from './pages/policies/CookiePolicy';
import Privacy_Policy from './pages/policies/PrivacyPolicy';
import TOS from './pages/policies/TOS';
import ManageGamesAccount from './pages/games_account/ManageGamesAccount.js';
import ExplorePremium from './pages/ExplorePremium.js';

import {
  Link,
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import './App.css';


function App() {
  return (
    <div className="App">
      <div className="pagecontainer">
        <Router>
          <div className='header'> 
            <div className='nav'>
              <div className='navWrapper'>
                <img src={logo} id='logo' alt='logo' draggable='false'/>
                <div id='navBar'>
                  <div id='siteNav'>
                    <Link to="/"><p>News</p></Link>
                    <Link to="/products"><p>Products</p></Link>
                    <Link to="/payment"><p>Payments</p></Link>
                    <Link to="/about"><p>About</p></Link>
                  </div>
                </div>
              </div>
            </div>
            <Link to="https://discord.com/invite/7EdpuVxVAS"><img id='discordLink' src={Discord} /></Link>
          </div>
          <div className="content">
            <Routes>
                <Route exact path="/cookiepolicy" element={<Cookie_Policy/>}/>
                <Route exact path="/privacypolicy" element={<Privacy_Policy/>}/>
                <Route exact path="/termsofservice" element={<TOS/>}/>
                <Route exact path="/" element={<Page_Home />} />
                <Route path="/products" element={<Page_Projects />} />
                <Route path="/about" element={<Page_About />} />
                <Route path="/payment" element={<Page_Payments />} />
                <Route path="/blackjackdemo" element={<Blackjack_Demo/>}/>
                <Route path="/manage-cwgames-account" element={<ManageGamesAccount/>}/>
                <Route path="/explore-premium" element={<ExplorePremium/>}/>
                <Route path="*" element={<Page_404/>} />
            </Routes>
          </div>
          <div id='footer'>
            <p>Copyright &copy; CW Creations All Rights Reserved 2021-2026</p>
          </div>
        </Router>
      </div>
    </div>
  );
}

export default App;
